import React, { useState, useEffect, useRef } from 'react';
import './Pingpong.css';

const Pingpong = () => {
  const [ball, setBall] = useState({ x: 50, y: 50, dx: 2, dy: 2 });
  const [leftPaddle, setLeftPaddle] = useState(40);
  const [rightPaddle, setRightPaddle] = useState(40);
  const [isGameRunning, setIsGameRunning] = useState(false);
  const [leftScore, setLeftScore] = useState(0);
  const [rightScore, setRightScore] = useState(0);
  const gameBoardRef = useRef(null);

  const movePaddle = (paddle, direction) => {
    if (paddle === 'left') {
      setLeftPaddle((prev) => Math.min(80, Math.max(0, prev + direction)));
    } else if (paddle === 'right') {
      setRightPaddle((prev) => Math.min(80, Math.max(0, prev + direction)));
    }
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'w') movePaddle('left', -10);
      if (e.key === 's') movePaddle('left', 10);
      if (e.key === 'ArrowUp') movePaddle('right', -10);
      if (e.key === 'ArrowDown') movePaddle('right', 10);
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  useEffect(() => {
    if (!isGameRunning) return;

    const moveBall = () => {
      setBall((prev) => {
        let { x, y, dx, dy } = prev;

        if (y + dy > 100 || y + dy < 0) dy = -dy;

        if (x + dx < 10) {
          if (y >= leftPaddle && y <= leftPaddle + 20) {
            dx = -dx;
          } else {
            setRightScore((score) => score + 1);
            setIsGameRunning(false);
            return { x: 50, y: 50, dx: -dx, dy };
          }
        }

        if (x + dx > 90) {
          if (y >= rightPaddle && y <= rightPaddle + 20) {
            dx = -dx;
          } else {
            setLeftScore((score) => score + 1);
            setIsGameRunning(false);
            return { x: 50, y: 50, dx: -dx, dy };
          }
        }

        return { x: x + dx, y: y + dy, dx, dy };
      });
    };

    const interval = setInterval(moveBall, 50);
    return () => clearInterval(interval);
  }, [isGameRunning, leftPaddle, rightPaddle]);

  const startGame = () => {
    setIsGameRunning(true);
  };

  const pauseGame = () => {
    setIsGameRunning(false);
  };

  const restartGame = () => {
    setLeftScore(0);
    setRightScore(0);
    setBall({ x: 50, y: 50, dx: 2, dy: 2 });
    setLeftPaddle(40);
    setRightPaddle(40);
    setIsGameRunning(true);
  };

  return (
    <div className="AppPP">
      <h1>Pong Game</h1>
      <div className="controls">
        <h2>Player 1: use 'W' for upwards and 's' for down in keyboard</h2>
        <h2>Player 2: use arrow keys in keyboard</h2>
        <button onClick={startGame}>Start Game</button>
        <button onClick={pauseGame}>Pause</button>
        <button onClick={restartGame}>Restart Game</button>
        <div className="scores">
          <div>Player 1 Score: {leftScore}</div>
          <div>Player 2 Score: {rightScore}</div>
        </div>
      </div>
      <div className="game-board" ref={gameBoardRef}>
        <div className="ball" style={{ top: `${ball.y}%`, left: `${ball.x}%` }}></div>
        <div className="paddle left" style={{ top: `${leftPaddle}%` }}></div>
        <div className="paddle right" style={{ top: `${rightPaddle}%` }}></div>
      </div>
      <div className="mobile-controls">
        <div>
          <button onClick={() => movePaddle('left', -10)}>↑</button>
          <button onClick={() => movePaddle('left', 10)}>↓</button>
        </div>
        <div>
          <button onClick={() => movePaddle('right', -10)}>↑</button>
          <button onClick={() => movePaddle('right', 10)}>↓</button>
        </div>
      </div>
    </div>
  );
};

export default Pingpong;
